<template>
  <div class="ui stackable four column middle aligned centered grid">
    <div class="four wide column" style="margin-top: 180px">
        <div class="ui raised padded segment">
          <h2 class="ui center aligned padded secondary header">
              Meine Insel Booking
          </h2>
          <form class="ui huge form" @submit.prevent="doLogin" :class="[{ 'error': error != '' }]">
            <div class="field">
              <div class="ui left icon input">
                <i class="user icon"></i>
                <input type="text" v-model="loginData.email" placeholder="E-mail address">
              </div>
            </div>
            <div class="field">
              <div class="ui left icon input">
                <i class="lock icon"></i>
                <input type="password" v-model="loginData.password" placeholder="Password">
              </div>
            </div>
            <button type="submit" class="ui fluid big primary submit button"><i class="sign in icon"></i> Login</button>
            <div class="ui error message" v-if="error">{{ error }}</div>
          </form>
        </div>
    </div>
  </div>
</template>

<script>
import app from '../../services/index'
import auth from '../../services/index'
import store from '../../store'

export default {
  data() {
      return {
          loginData: {
              email: '',
              password: ''
          },
          error: ''
      }
  },
  methods: {
    doLogin() {
        this.error = null

        auth.authenticate({
          type: 'local',
          'email': this.loginData.email,
          'password': this.loginData.password
        }).then(function (result) {
            store.dispatch('authenticateUser', app.get('user'))
            this.$router.push('/admin')
            toastr.success('Hi, you have successfully logged in!', 'Logged in!')
          }.bind(this)
        ).catch(function (error) {
          toastr.error(error.message, 'Problem logging in!')
        }.bind(this))
    }
  },
  components: {
//    Tasks
  }
}
</script>

<style>
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?44569e64